import React, { useEffect, useState, useRef } from "react";
//import { useState } from "react";
import SearchComponent from "../../Search/SearchComponent/SearchComponent";
//import { Link } from 'react-router-dom';
//import "./tramites.css";
import { convenios } from "../../../json/convenios";

const Convenios = () => {
  const [search, setSearch] = useState("");
  const searchInput = useRef();
  var tramitesyserv = "";
  tramitesyserv = JSON.stringify(convenios);
  tramitesyserv = JSON.parse(tramitesyserv);

  const searchTram = () => {
    tramitesyserv = JSON.stringify(convenios);
    tramitesyserv = JSON.parse(tramitesyserv);
    setSearch(searchInput.current.value);
  };

  let filterTram = tramitesyserv.filter((tramite) => {
    let tramites = tramite.tramites_array;
    if (!tramite.tramite_loc.toLowerCase().includes(search.toLowerCase())) {
      tramite.tramites_array = tramites.filter((tramiteDet) => {
        return tramiteDet.tramite_item_nombre
          .toLowerCase()
          .includes(search.toLowerCase());
      });
    }
    if (
      tramite.tramites_array.length > 0 ||
      tramite.tramite_loc.toLowerCase().includes(search.toLowerCase())
    ) {
      return tramite;
    }
  });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="container transparencia-container">
      <div className="row">
        <div className="col-12">
          <div className="transparencia_title">
            <h1>Convenios</h1>
          </div>
        </div>
      </div>
      <SearchComponent
        searchInput={searchInput}
        search={search}
        searchTram={searchTram}
      />
      <div className="row">
            {filterTram.map((item, index) => (
              <div key={index} className="col-sm-4 d-flex align-items-stretch">
                  <div class="card w-100">
                    <div class="card-body" className="text-justify m-3">
                    {item.tramites_array.map((tram, i) => (
                                  <a 
                                    target="{ _blank }"
                                    key={i}
                                    href={tram.transparencia_item_url}
                                  >
                                    {tram.tramite_item_nombre}
                                  </a>
                                                                
                              ))}<br></br>
                         <p class="card-text">{item.tramite_loc}</p>

                    </div>
                  
                  </div>
              </div>
            ))}
      </div>
      
    </div>
  );
};

export default Convenios;
